import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dcd01ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing course-details-card" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body p-10\" data-v-4dcd01ac><div class=\"bg-gradient ps-15 pe-15 pt-20 pb-20 ps-md-30 pe-md-30 pt-md-30 pb-md-30 ps-lg-40 pe-lg-40 pt-lg-40 pb-lg-40\" data-v-4dcd01ac><div class=\"course-details-header\" data-v-4dcd01ac><span class=\"d-inline-block bg-warning fs-12 fw-medium rounded-1 ps-10 pe-10 pt-1 pb-1 mb-10 text-black\" data-v-4dcd01ac> Asignación académica </span><h2 class=\"fw-bold text-white\" data-v-4dcd01ac>Plan Académico — Asignación por grupo</h2><p class=\"lh-base fs-md-15 fs-lg-16\" data-v-4dcd01ac> Selecciona las materias para cada docente dentro de cada grupo y registra horas/capacidad del docente. </p><div class=\"info d-sm-flex align-items-center\" data-v-4dcd01ac><div class=\"reviews d-flex align-items-center\" data-v-4dcd01ac><div class=\"rating lh-1\" data-v-4dcd01ac><i class=\"flaticon-star-1\" data-v-4dcd01ac></i><i class=\"flaticon-star-1\" data-v-4dcd01ac></i><i class=\"flaticon-star-1\" data-v-4dcd01ac></i><i class=\"flaticon-star-1\" data-v-4dcd01ac></i><i class=\"flaticon-star-1\" data-v-4dcd01ac></i></div><span class=\"fw-bold fs-13 ms-5 me-8 text-white\" data-v-4dcd01ac>Vista árbol</span><span data-v-4dcd01ac>Grupos → Docentes → Materias</span></div></div></div></div></div>", 1)
const _hoisted_3 = { class: "card-body pt-10 pb-10 ps-10 pe-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Sede", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Año académico", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Grupo", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Docente", -1))
const _hoisted_8 = { class: "pe-xxl-25 pe-xxxl-50" }
const _hoisted_9 = { class: "card-body pt-0 pb-0 ps-10 pe-10" }
const _hoisted_10 = {
  class: "accordion",
  id: "groupsAccordion"
}
const _hoisted_11 = ["data-bs-target", "aria-controls"]
const _hoisted_12 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "number bg-primary text-center text-white rounded-circle fs-13 fw-semibold" }
const _hoisted_15 = { class: "ms-10" }
const _hoisted_16 = { class: "text-muted ms-10" }
const _hoisted_17 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled" }
const _hoisted_18 = { class: "position-relative fw-medium fs-13 text-muted me-15" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "accordion-body" }
const _hoisted_22 = ["id"]
const _hoisted_23 = ["data-bs-target", "aria-controls"]
const _hoisted_24 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_25 = { class: "d-flex align-items-center sub-teacher-indent" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play me-8" }, null, -1))
const _hoisted_27 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled" }
const _hoisted_28 = { class: "position-relative fw-medium fs-13 text-muted me-15" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" }, null, -1))
const _hoisted_30 = { class: "fw-semibold" }
const _hoisted_31 = { class: "position-relative fw-medium fs-13 text-muted" }
const _hoisted_32 = ["id", "data-bs-parent"]
const _hoisted_33 = { class: "accordion-body" }
const _hoisted_34 = { class: "table-responsive" }
const _hoisted_35 = { class: "text-center text-success my-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Registrando asignación...", -1))
const _hoisted_37 = { class: "fw-bold text-primary" }
const _hoisted_38 = { class: "text-muted fs-12" }
const _hoisted_39 = { class: "d-flex align-items-center gap-6" }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = { class: "mt-10 d-flex justify-content-between align-items-center" }
const _hoisted_42 = { class: "text-muted fs-13" }
const _hoisted_43 = {
  key: 0,
  class: "text-muted fs-13"
}
const _hoisted_44 = {
  key: 0,
  class: "text-muted fs-14 mt-10"
}
const _hoisted_45 = { class: "card-body pt-10 pb-15 ps-10 pe-10" }
const _hoisted_46 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_b_row, { class: "g-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.headquarterId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.headquarterId) = $event)),
                    options: _ctx.headquarterOptions,
                    placeholder: "Todas las sedes"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.academicYearId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.academicYearId) = $event)),
                    options: _ctx.academicYearOptions,
                    disabled: _ctx.isEditing,
                    placeholder: "Todos los años"
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.courseGroupId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.courseGroupId) = $event)),
                    options: _ctx.groupOptions,
                    placeholder: "Todos los grupos"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.filters.teacherId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.teacherId) = $event)),
                    options: _ctx.teacherOptions,
                    disabled: _ctx.isEditing,
                    placeholder: "Todos los docentes"
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsForTree, (grp, gIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: grp.Id,
              class: "accordion-item border-0"
            }, [
              _createElementVNode("button", {
                class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fw-medium rounded-0 bg-white border-0",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#grp-${grp.Id}`,
                "aria-controls": `grp-${grp.Id}`
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(gIdx + 1), 1),
                    _createElementVNode("span", _hoisted_15, [
                      _createTextVNode(_toDisplayString(grp.Name || ('Grupo ' + grp.Id)) + " ", 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(grp.CourseName || 'N/D') + " - " + _toDisplayString(grp.HeadquarterName || 'Sin sede') + " - " + _toDisplayString(grp.AcademicYearName || 'N/D'), 1)
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_17, [
                    _createElementVNode("li", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_ctx.teachersForUI.length) + " profesores ", 1)
                    ])
                  ])
                ])
              ], 8, _hoisted_11),
              _createElementVNode("div", {
                id: `grp-${grp.Id}`,
                class: "accordion-collapse collapse",
                "data-bs-parent": "#groupsAccordion"
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: "accordion",
                    id: `teachersAccordion-${grp.Id}`
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teachersForUI, (tch) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: tch.Id,
                        class: "accordion-item border-0"
                      }, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed d-block w-100 text-start text-black fs-13 fw-medium rounded-0 bg-white border-0",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": `#grp-${grp.Id}-tch-${tch.Id}`,
                          "aria-controls": `grp-${grp.Id}-tch-${tch.Id}`
                        }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("span", null, _toDisplayString(_ctx.teacherLabel(tch)), 1)
                            ]),
                            _createElementVNode("ul", _hoisted_27, [
                              _createElementVNode("li", _hoisted_28, [
                                _hoisted_29,
                                _createTextVNode(" Seleccionadas: "),
                                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.getNodeSelectedCount(grp.Id, tch.Id)), 1)
                              ]),
                              _createElementVNode("li", _hoisted_31, [
                                _createVNode(_component_b_form_checkbox, {
                                  modelValue: _ctx.showOnlySelectedMap[_ctx.nodeKey(grp.Id, tch.Id)],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.showOnlySelectedMap[_ctx.nodeKey(grp.Id, tch.Id)]) = $event),
                                  class: "me-6"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Mostrar solo seleccionadas ")
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_23),
                        _createElementVNode("div", {
                          id: `grp-${grp.Id}-tch-${tch.Id}`,
                          class: "accordion-collapse collapse",
                          "data-bs-parent": `#teachersAccordion-${grp.Id}`
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_b_table, {
                                items: _ctx.subjectRowsForNode(grp.Id, tch.Id),
                                fields: _ctx.subjectTableHeaders,
                                class: "table table-sm table-ultra-compact text-nowrap mb-0",
                                small: "",
                                hover: "",
                                busy: _ctx.table.loading,
                                "show-empty": ""
                              }, {
                                "table-busy": _withCtx(() => [
                                  _createElementVNode("div", _hoisted_35, [
                                    _createVNode(_component_b_spinner, { class: "align-middle" }),
                                    _hoisted_36
                                  ])
                                ]),
                                "cell(Selected)": _withCtx(({ item }) => [
                                  _createVNode(_component_b_form_checkbox, {
                                    "model-value": _ctx.isSelected(item._ctx.g, item._ctx.t, item.Id),
                                    "onUpdate:modelValue": (val) => _ctx.onToggleSelection(
                                  item._ctx.g, item._ctx.t, item.Id, val,
                                  item.HoursPerWeek || 1, item.HoursPerWeek || 0
                                )
                                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                                ]),
                                "cell(SubjectName)": _withCtx(({ item }) => [
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(item.Name), 1),
                                  _createElementVNode("div", _hoisted_38, _toDisplayString(item.Code), 1)
                                ]),
                                "cell(HoursToAssign)": _withCtx(({ item }) => [
                                  _createVNode(_component_b_form_input, {
                                    "model-value": _ctx.currentAssigned(item._ctx.g, item._ctx.t, item.Id),
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    class: "form-control form-control-sm shadow-none w-80px text-center",
                                    "onUpdate:modelValue": (val) => _ctx.onHoursChange(item._ctx.g, item._ctx.t, item.Id, Number(val) || 0)
                                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                                ]),
                                "cell(TeacherHoursCapacity)": _withCtx(({ item }) => [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createVNode(_component_b_form_input, {
                                      "model-value": _ctx.currentCapacity(item._ctx.g, item._ctx.t, item.Id, item.HoursPerWeek || 0),
                                      type: "number",
                                      min: "0",
                                      step: "1",
                                      class: "form-control form-control-sm shadow-none w-80px text-center",
                                      "onUpdate:modelValue": (val) => _ctx.onCapacityChange(item._ctx.g, item._ctx.t, item.Id, Number(val) || 0)
                                    }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                    _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.currentAssigned(item._ctx.g, item._ctx.t, item.Id)) + " / " + _toDisplayString(_ctx.currentCapacity(item._ctx.g, item._ctx.t, item.Id, item.HoursPerWeek || 0)), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["items", "fields", "busy"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createTextVNode(" Seleccionadas: "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.getNodeSelectedCount(grp.Id, tch.Id)), 1),
                                _createTextVNode(" · Horas totales a asignar: "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.totalHoursByGroupTeacher(grp.Id, tch.Id)), 1)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_32)
                      ]))
                    }), 128)),
                    (!_ctx.teachersForUI.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, "No hay profesores según el filtro."))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_22)
                ])
              ], 8, _hoisted_20)
            ]))
          }), 128)),
          (!_ctx.groupsForTree.length && !_ctx.table.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " No hay grupos que cumplan los filtros. "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createVNode(_component_b_button, {
          variant: "success",
          class: "default-btn transition border-0 fw-medium text-white py-10 px-25 rounded-1 fs-14",
          disabled: !_ctx.canRegister,
          onClick: _ctx.onRegisterAll
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Registrar carga académica ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}